export class GaussianFit {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "mu",
            "baseName": "mu",
            "type": "number",
            "format": "double"
        },
        {
            "name": "sigma",
            "baseName": "sigma",
            "type": "number",
            "format": "double"
        }
    ];
    static getAttributeTypeMap() {
        return GaussianFit.attributeTypeMap;
    }
    constructor() {
    }
}
